import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { set } from 'idb-keyval'
import { omit } from 'lodash'
import { useDispatch } from 'react-redux'

import { GetMapByIdResults, getMapById } from '~map-preview/api/getMapById'
import { setMapData, useIsMapSaved } from '~map-preview/states/map'

export const getMapByIdQueryKey = (mapId: string) => ['getMapById', mapId]

function useGetMapById(mapId: string): UseQueryResult<GetMapByIdResults> {
  const isMapSaved = useIsMapSaved()
  const dispatch = useDispatch()

  const query = useQuery({
    enabled: isMapSaved,
    queryKey: getMapByIdQueryKey(mapId),
    queryFn: async () => {
      const map = await getMapById({ id: mapId })
      dispatch(setMapData(map))

      const persistMap = omit(map, ['liked'])
      await set(mapId, persistMap)

      return map
    }
  })

  return query
}

export { useGetMapById }
